import { Group } from "../../types/group/group.type";
import { Section } from "../../types/group/section.type";
import GroupUtil from "./group-util";

export class SectionUtil {
  private section: Section;

  constructor(section: Section) {
    this.section = section;
  }

  /**
   * Check if user can create post in the section
   */
  public canCreatePost(group: Group): boolean {
    const section = this.section;
    if (!section) { return false; }

    // Restrict user to create post in realtime section
    else if (section.sectionType === "realtime") {
      return false
    }
    return this.canSendMessage(group);
  }

  /**
   * Check who can send message in realtime section
   */
  public canSendMessage(group: Group): boolean {
    const section = this.section;
    if (!section) { return false; }
    const groupUtil = new GroupUtil(group);

    // if section is closed or private
    if (section.isClosed) {

      // Allow only group admin to create post in section if postLevel is admin
      if (section.postLevel === "admin") {
        return groupUtil.hasAdminAccess();

      } else {
        return groupUtil.hasAnyAccess() || section.isJoined;
      }
    } else {

      // check if user is member of group or not
      //  Allow user to create post only if
      // 1. Group is open and  section has postLevel as anyone
      // 2. Group is closed and section has postLevel as anyone. Any role is required in group
      // 3. Group is closed and section has postLevel as admin. Admin role is required in group

      // Use case 1
      if (groupUtil.isOpen() && section.postLevel === "anyone") {
        return true;
      }
      // Use case 2
      else if (groupUtil.isClosed() && section.postLevel === "anyone") {
        return groupUtil.hasAnyAccess();
      }

      // Use case 3
      else if (groupUtil.isClosed() && section.postLevel === "admin") {
        return groupUtil.hasAdminAccess();
      }

      return this.section.postLevel === "anyone"
    }

  }
}